<template>
  <Code />
</template>

<script>
import Code from '@/components/content/education/training/TrainingContentCode.vue'

export default {
  name: 'ContentTrainingCode',
  components: { Code }
}
</script>

<style scoped>

</style>
